module.exports = __webpack_public_path__ + "static/media/std_deviation_output.e179f818.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/info/std_deviation_output.png
// module id = 2354
// module chunks = 0